import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=0f192903&scoped=true&"
import script from "./Postcode.vue?vue&type=script&lang=js&"
export * from "./Postcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f192903",
  null
  
)

export default component.exports